'use strict';

module.exports = '2.28.0';